<template>
    <slot :loading="loading" :result="result" :packs="packs" :selectedPack="selectedPack" :openPrices="openPrices" :openPacks="openPacks" :bookNow="bookNow"></slot>
</template>

<script>
import { defineComponent, ref, onBeforeMount, onBeforeUnmount } from 'vue';
import { uniqBy, sortBy } from 'lodash';

import eventBus from './utils/event-bus';
import { getSeriesById } from '../services/inventory';

export default defineComponent({
    name: 'SeriesPackHeader',
    props: {
        primary: {
            type: Boolean,
            required: false,
            default: false,
        },
        seriesId: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const loading = ref(true);
        const packs = ref(null);
        const selectedPack = ref(null);
        const result = ref({});

        const processResults = () => {
            if (!selectedPack.value) {

                if(packs.value === null) {
                    return;
                }

                let events = packs?.value?.map(pack => {
                    return pack.events;
                });

                // flatten it
                events = [].concat(...events);

                // remove duplicates
                events = uniqBy(events, 'id');

                // sort by start day
                events = sortBy(events, 'startDate');

                result.value = {
                    title: 'All Concerts',
                    suffix: null,
                    events,
                }
            } else {
                result.value = selectedPack.value;
            }
        }

        const openPrices = () => {
            eventBus.emit('pricesPopup:open');
        }

        const openPacks = () => {
            eventBus.emit('packsPopup:open');
        }

        const bookNow = () => {
            if (!props.primary) {
                eventBus.emit('bookNow');
                return;
            }

            if (selectedPack.value.is_create_your_own) {
                window.location.href = `${AppConfig.boDomain.replace(/^\/|\/$/g, '')}/booking/package/flex/${selectedPack.value.package_id}`;
            } else {
                window.location.href = `${AppConfig.boDomain.replace(/^\/|\/$/g, '')}/booking/package/${selectedPack.value.package_id}`;
            }
        }

        const handlePackChange = pack => {
            selectedPack.value = pack;
            processResults();
        }

        onBeforeMount(() => {
            getSeriesById(props.seriesId).then(series => {
                packs.value = series?.doc?.theme?.settings.package_days;

                if(packs.value.length === 1) {
                    selectedPack.value = packs.value[0];
                }

                if (props.primary) {
                    eventBus.emit('seriesPacks', packs.value);
                }
            }).finally(() => {
                processResults();

                eventBus.on('packChanged', handlePackChange);
                eventBus.on('bookNow', bookNow);

                loading.value = false;
            });
        });

        onBeforeUnmount(() => {
            eventBus.off('packChanged', handlePackChange);
            eventBus.off('bookNow', bookNow);
        });

        return {
            loading,
            packs,
            selectedPack,
            result,
            openPrices,
            openPacks,
            bookNow,
        }
    },
});
</script>
